export default __webpack_public_path__ + "static/media/awesome-arrow-left.0809531c.svg";